/* Robotow swipe rows: position, real previous / next buttons, arrow keys. No auto-advance.
   Every slide is in the page without this file; it only adds the controls and the scroll-in reveal. */
(function () {
  "use strict";
  var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function init(root) {
    var track = root.querySelector("[data-car-track]"), bar = root.querySelector("[data-car-bar]");
    if (!track || !bar) return;
    var pos = bar.querySelector("[data-car-pos]"), total = bar.querySelector("[data-car-total]");
    var prev = bar.querySelector("[data-car-prev]"), next = bar.querySelector("[data-car-next]");
    var noun = track.getAttribute("data-car-label") || "";
    var labelled = track.hasAttribute("data-car-label");
    var frame = track.parentElement && track.parentElement.closest(".rt-fits-scroll");
    var slides = [], cur = -1, raf = 0;

    function pad() { return parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0; }
    function collect() {
      // a slide hidden at this width (phones-only or wide-only) is not counted
      slides = Array.prototype.filter.call(track.children, function (s) { return s.getClientRects().length > 0; });
      if (total) total.textContent = slides.length;
      if (labelled) slides.forEach(function (s, i) { s.setAttribute("aria-label", (noun ? noun + " " : "") + (i + 1) + " of " + slides.length); });
    }
    function at() {
      var x = track.scrollLeft + pad(), best = 0, d = Infinity;
      slides.forEach(function (s, i) { var dd = Math.abs(s.offsetLeft - x); if (dd < d) { d = dd; best = i; } });
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2) best = slides.length - 1;
      return best;
    }
    function show(i) {
      if (i === cur) return;
      cur = i;
      pos.textContent = i + 1;
      prev.disabled = i === 0;
      next.disabled = i === slides.length - 1;
    }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - pad(), behavior: reduced ? "auto" : "smooth" });
      show(i);
    }
    function sync() {
      collect();
      bar.hidden = track.scrollWidth <= track.clientWidth + 2;
      // a row that does not scroll at this width is not a tab stop
      if (bar.hidden) track.removeAttribute("tabindex"); else track.setAttribute("tabindex", "0");
      // a table's own sideways frame steps out of the tab order while the row inside it swipes
      if (frame) frame.setAttribute("tabindex", bar.hidden ? "0" : "-1");
      cur = -1;
      show(at());
    }
    track.addEventListener("scroll", function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { show(at()); });
    }, { passive: true });
    prev.addEventListener("click", function () { go(cur - 1); });
    next.addEventListener("click", function () { go(cur + 1); });
    track.addEventListener("keydown", function (e) {
      if (e.target !== track) return;
      var k = e.key;
      if (k === "ArrowRight") go(cur + 1);
      else if (k === "ArrowLeft") go(cur - 1);
      else if (k === "Home") go(0);
      else if (k === "End") go(slides.length - 1);
      else return;
      e.preventDefault();
    });
    window.addEventListener("resize", sync);
    sync();
  }

  /* Phones only. Only blocks still below the fold get armed, so nothing visible ever blinks out. A scroll check
     (not IntersectionObserver) so a fast fling can never skip a block and leave it hidden. */
  function reveal() {
    if (reduced || !window.matchMedia("(max-width: 749px)").matches) return;
    var armed = [];
    Array.prototype.forEach.call(document.querySelectorAll(".rt:not(.rt-hero) > .rt-wrap"), function (el) {
      if (el.getBoundingClientRect().top > window.innerHeight) { el.classList.add("rt-reveal"); armed.push(el); }
    });
    if (!armed.length) return;
    var raf = 0;
    function check() {
      raf = 0;
      var edge = window.innerHeight * 0.92;
      armed = armed.filter(function (el) {
        if (el.getBoundingClientRect().top < edge) { el.classList.add("is-in"); return false; }
        return true;
      });
      if (!armed.length) { window.removeEventListener("scroll", onScroll, true); window.removeEventListener("resize", onScroll); }
    }
    function onScroll() { if (!raf) raf = requestAnimationFrame(check); }
    window.addEventListener("scroll", onScroll, { passive: true, capture: true });
    window.addEventListener("resize", onScroll);
  }

  function start() { Array.prototype.forEach.call(document.querySelectorAll("[data-rt-carousel]"), init); reveal(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
})();
